<template>
  <v-card
    v-if="allCategories.length"
    width="100%"
    id="allCategories"
    flat
    color="transparent"
  >
    <v-card-title class="px-0 py-2">
      <h2 class="black--text homepageTitle">{{ title }}</h2>
    </v-card-title>

    <v-card-text class="px-0">
      <ItemGroup
        :items="allCategories"
        itemImgSrc="PictureUrl"
        itemText="Name"
        :wrap="wrap"
        @select="onCategoryClick"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { addLog } from '@/api/dssRequest';
import UserJS from '@/objects/UserObject';
import ItemGroup from '@/components/generalComponents/uiComponents/ItemGroup';
import uiHelpers from '../../shared/ui_helpers';

export default {
  name: 'AllCategories',
  mixins: [uiHelpers],
  props: {
    /**
     * Wrap items instead of overflowing to the right
     */
    wrap: Boolean,
  },
  components: {
    ItemGroup,
  },
  computed: {
    allCategories() {
      return this.$store.getters['user/productCategories'];
    },
    pgrInfo() {
      return this.$store.getters['Account/partnerGroupDetails'];
    },
    title() {
      if (
        this.pgrInfo != null &&
        this.pgrInfo.ProductFocusTitle != null &&
        this.pgrInfo.ProductFocusTitle.trim() !== ''
      ) {
        return this.pgrInfo.ProductFocusTitle.trim();
      }
      return this.$translate('CATEGORIES_TITLE');
    },
  },
  mounted() {
    UserJS.getProductCategories();
  },
  methods: {
    onCategoryClick(category) {
      this.$store.commit('setCurrentDetailsForEventPage', {});
      this.$store.commit('setCurrentDetailsForEventPage', {
        Type: 'ProductCategory',
        Id: category.Id,
        Description: category.Description,
        Name: category.Name,
        Picture: category.PictureUrl,
        Video: '',
        PortraitVideo: '',
      });

      addLog(
        this.$store.getters['auth/userName'],
        category.Id,
        'ProductCategory',
        'Home',
        -1
      );

      this.goToPage('ProductCategory', {
        event_id: category.EventId,
        category_id: category.Id,
      });
    },
  },
};
</script>
